<template>
  <div class="event-menu">
    <button class="back-btn" @click="$emit('back')">← Назад</button>
    <h2>{{ eventName }}</h2>

    <button class="admin-btn" @click="$emit('open-admin')">
      Админ ({{ eventName }})
    </button>

    <h3>Судьи</h3>
    <div class="judges">
      <button
        v-for="judge in allJudges"
        :key="judge"
        class="judge-btn"
        @click="$emit('enter-judge', judge)"
      >
        {{ judge }}
      </button>
      <p v-if="allJudges.length === 0" class="no-judges">Судьи не добавлены</p>
    </div>

    <button class="results-btn" @click="$emit('open-results')">
      Результаты события
    </button>
  </div>
</template>

<script>
export default {
  props: { eventName: String, eventData: Object },
  computed: {
    allJudges() {
      const set = new Set();
      Object.values(this.eventData.participants).forEach((cat) => {
        Object.keys(cat).forEach((j) => set.add(j));
      });
      return Array.from(set).sort();
    },
  },
  methods: {
    enterAsJudge(j) {
      alert(`Вход как ${j} — в разработке`);
    },
    goToResults() {
      alert("Результаты — в разработке");
    },
  },
};
</script>

<style scoped>
.event-menu {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}
.admin-btn {
  background: #ff9800;
}
.judge-btn {
  background: #4caf50;
}
.results-btn {
  background: #2196f3;
}
.admin-btn,
.judge-btn,
.results-btn {
  display: block;
  width: 100%;
  padding: 18px;
  margin: 12px 0;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  cursor: pointer;
}
.no-judges {
  color: #999;
  font-style: italic;
  text-align: center;
}
</style>